"use client";
import Skeleton from "react-loading-skeleton";
import {
  useFetchMainAccessPoint,
  useOrganisationCategories,
  generateAbbreviation,
} from "../../lib/util";
import styles from "./index.module.css";
import { emptyState } from "../../assets";
import { useEffect, useState } from "react";
import Carousel from "../carousel/carousel";
import { useAppDispatch } from "../slice/hooks";
import { setActiveCategory } from "../slice/category-slice";

const CARD_WIDTH = "34rem";
const CARD_HEIGHT = "27rem";

const LoadingCategoryCard = ({ style }) => {
  return (
    <div
      style={{
        width: CARD_WIDTH,
        height: CARD_HEIGHT,
        borderRadius: 8,
        marginRight: "0.5rem",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        gap: "1rem",
        ...style,
      }}
    >
      <div style={{ width: "60%", margin: "0 auto" }}>
        <Skeleton width={"100%"} height={20} />
      </div>

      <div style={{ flex: 1, minHeight: 0 }}>
        <Skeleton
          width={"100%"}
          height={"100%"}
          style={{ borderRadius: 8, display: "block" }}
        />
      </div>
    </div>
  );
};

const OrganisationCategories = ({ org, token, handleSwitch }) => {
  const orgId = org?.orgId;
  const dispatch = useAppDispatch();
  const [mainAccessPointId, setMainAccessPointId] = useState("");
  const { mutate: fetchMainAccessPoint } = useFetchMainAccessPoint({
    onError: (error) => {
      console.error("Failed to fetch main access point:", error);
    },
    onSuccess: (response) => {
      setMainAccessPointId(response?.data.accessPoint?.accessPointId);
    },
  });

  useEffect(() => {
    if (orgId && token) {
      fetchMainAccessPoint({ orgId, token });
    }
  }, [orgId, token]);

  const { data, isLoading } = useOrganisationCategories(
    orgId,
    token,
    mainAccessPointId
  );

  if (isLoading) {
    return (
      <>
        {Array.from({ length: 5 }).map((_, i) => (
          <LoadingCategoryCard key={i} />
        ))}
      </>
    );
  }

  const categories = data?.productCategories || [];
  if (!categories.length) {
    return (
      <div className={styles.emptyState}>
        <p>There are no categories available for this Organisation</p>
        <div>{emptyState}</div>
      </div>
    );
  }

  return categories.map((category) => {
    const hasProducts = category.products && category.products.length > 0;

    console.log({ category });

    // Build media array for carousel
    const media = category.products
      ?.map((product) => product.media?.[0])
      .filter(Boolean)
      .map((m) => ({
        mediaUrl: m.mediaUrl,
        mediaThumb: m.mediaThumb,
        mediaName: m.mediaName,
        mediaType: m.mediaType,
        mediaExt: m.mediaExt,
        mediaWidth: m.mediaWidth,
        mediaHeight: m.mediaHeight,
        mediaTime: m.mediaTime,
        _id: m._id,
      }));

    return (
      <div
        key={category.categoryId}
        className={styles.organisationCategory}
        onClick={(e) => {
          e.stopPropagation();
          dispatch(setActiveCategory(category.productCategoryId));
          handleSwitch(org);
        }}
      >
        <h4>{category.name}</h4>

        {hasProducts ? (
          <div style={{ overflow: "hidden" }}>
            <Carousel
              media={media}
              enablePreview={false}
              autoscroll={true}
              showIndicator={false}
              hideThumb={true}
              inMarketPlace={true}
            />
          </div>
        ) : (
          <div
            style={{
              width: "30rem",
              height: "29rem",
              padding: "1rem 1.5rem",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f0f0f0",
                borderRadius: "15px",
                marginRight: "0.5rem",
                fontSize: "5rem",
                color: "#444",
                textTransform: "uppercase",
                fontWeight: 600,
              }}
            >
              {generateAbbreviation(category.name)}
            </div>
          </div>
        )}
      </div>
    );
  });
};

export default OrganisationCategories;
